import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { Button } from "@/components/ui/button";
import { getInvoiceCorrections } from "@/service/weexpertService";

export const RelatedCorrectionsSection = ({ invoiceId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['invoiceCorrections', invoiceId],
    queryFn: () => getInvoiceCorrections(invoiceId),
    enabled: !!invoiceId,
  });

  const corrections = data?.data?.corrections || data?.data || [];

  if (isLoading) {
    return null;
  }

  if (corrections.length === 0) {
    return null;
  }

  return (
    <div className="w-full pb-6">
      <div className="text-xl font-medium pb-6">
        {t("invoices:corrections_list")}
      </div>

      <div className="bg-white rounded-md border p-4">
        <div className="space-y-2">
          {corrections.map((correction) => {
            // Support both API formats: correctionInvoiceId/correctionInvoiceNumber and id/invoiceId
            const correctionId = correction.correctionInvoiceId || correction.id;
            const correctionNumber = correction.correctionInvoiceNumber || correction.invoiceId;

            return (
              <div
                key={correctionId}
                className="flex items-center justify-between p-2 hover:bg-gray-50 rounded"
              >
                <div className="flex items-center gap-4">
                  <span className="font-medium">{correctionNumber}</span>
                  <span className="text-sm text-gray-500">
                    {new Date(correction.createdAt).toLocaleDateString()}
                  </span>
                  {correction.correctionReason && (
                    <span className="text-sm text-gray-400 truncate max-w-[200px]">
                      {correction.correctionReason}
                    </span>
                  )}
                </div>
                <Button
                  variant="link"
                  className="text-blueText"
                  onClick={() => navigate(`/admin/invoices/details/${correctionId}`)}
                >
                  {t("common:button_view")}
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
